import { transformAssetToImageProps } from '@modules/prism-client/lib/asset-to-image-props';
import { Image } from '@tuic/web-compositions/shared/Image';

import type { AssetRatio } from '@modules/prism-client/lib/asset-to-image-props';
import type PrismAPI from '@modules/prism-client/types/prism-types';
import type { ImageProps } from '@tuic/web-compositions/shared/Image';
import type { FC } from 'react';

type Props = { data: PrismAPI.Asset; ratio?: AssetRatio } & Omit<
  ImageProps,
  'src' | 'alt' | 'description'
>;

export const Asset: FC<Props> = ({ data, ratio, ...props }) => {
  const assetToImageProps = transformAssetToImageProps(data, { ratio });

  return (
    <Image
      {...props}
      {...assetToImageProps}
      sizes={props.sizes ?? assetToImageProps.sizes}
    />
  );
};
